import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "39",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "21.207",
      cy: "20.105",
      fill: "#0093E5",
      rx: "18.824",
      ry: "18.648"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "19.096",
      cy: "19.402",
      fill: "#52C1FF",
      rx: "18.824",
      ry: "18.648"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M26.723 10.713a1.925 1.925 0 0 0-2.76.7L18.36 21.918a1.76 1.76 0 0 1-2.734.474l-3.315-3.008a1.875 1.875 0 1 0-2.5 2.794l5.421 4.785a3.518 3.518 0 0 0 5.444-1.003l6.69-12.747a1.925 1.925 0 0 0-.643-2.5"
    }, null, -1)
  ])))
}
export default { render: render }